import { BorderedInput, Checkbox, Typography } from '@navi/web-ui/lib/primitives';
import React, { useEffect, useState } from 'react';
import { IRenderingEngine } from '../interfaces/index.type';

import styles from '../index.module.scss';
import RequiredCheckboxInput from './RequiredCheckboxInput';
import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';

const PhoneNumber: React.FC<IRenderingEngine> = ({
  question,
  register,
  error,
  source,
  setValue,
  getValue,
  unregister,
  clearErrors
}) => {
  const { text, mandatory, defaultValue, referenceId, metadata } = question;
  const [noPhoneNumberGivenFlag, setNoPhoneNumberGivenFlag] = useState(false);
  const [cachedValue, setCachedValue] = useState<{ prev: string; current: string }>({
    prev: defaultValue || '',
    current: defaultValue || ''
  });
  useEffect(() => {
    return () => {
      setValue(`${source}_${referenceId}`, undefined);
      unregister(`${source}_${referenceId}`);
      clearErrors(`${source}_${referenceId}`);
    };
  }, []);

  const validatePhoneNumber = value => {
    if (noPhoneNumberGivenFlag) {
      return true;
    }

    if (Number.isNaN(Number(value))) {
      return false;
    }
    if (!value) {
      return false;
    }
    if (value.length !== 10) {
      return false;
    }
  };

  return (
    <>
      <div key={`${source}_${referenceId}_${noPhoneNumberGivenFlag}`} className={styles.input}>
        <BorderedInput
          labelClassName={styles.label}
          id="phoneNumber"
          inputSize="full-width"
          type="tel"
          maxLength={10}
          minLength={10}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          inputLabel={
            <>
              {text} {mandatory && <RequiredIcon />}
            </>
          }
          value={cachedValue.current}
          LeftInputAdornment="+91"
          error={!!error?.[`${source}_${referenceId}`]}
          {...register(`${source}_${referenceId}`, {
            required: mandatory && (metadata?.isBlankValueAllowed ? !noPhoneNumberGivenFlag : true),
            validate: validatePhoneNumber
          })}
          disabled={noPhoneNumberGivenFlag}
        />
      </div>
      {error?.[`${source}_${referenceId}`] && (
        <Typography variant="p5" className={styles.errorText}>
          Please enter a valid phone number
        </Typography>
      )}
      {metadata?.isBlankValueAllowed ? (
        <RequiredCheckboxInput
          setValue={setValue}
          getValue={getValue}
          source={source}
          question={question}
          noDataGivenFlag={noPhoneNumberGivenFlag}
          setNoDataGivenFlag={setNoPhoneNumberGivenFlag}
          cachedValue={cachedValue}
          setCachedValue={setCachedValue}
          className={styles.input}
          title={'No Phone Number Given'}
        />
      ) : null}
    </>
  );
};

export default PhoneNumber;
